import React from 'react';
import { Modal } from 'antd';
import './detail-panel.css';

/** Shared detail modal shell with blur backdrop and consistent spacing. */
export default function AppDetailModal({
  open,
  title,
  subtitle,
  onCancel,
  footer = null,
  width = 820,
  loading = false,
  children,
  className = '',
  headerExtra = null,
  overflowMenu = null,
}) {
  const modalTitle = (
    <div className="detail-modal-header">
      <div className="detail-modal-header-text">
        <div className="detail-modal-title">{title}</div>
        {subtitle ? (
          <div className="detail-modal-subtitle">{subtitle}</div>
        ) : null}
      </div>
      {(headerExtra || overflowMenu) ? (
        <div className="detail-modal-header-actions">
          {headerExtra}
          {overflowMenu}
        </div>
      ) : null}
    </div>
  );

  return (
    <Modal
      className={`tools-detail-modal ${className}`.trim()}
      title={modalTitle}
      open={open}
      onCancel={onCancel}
      footer={footer}
      width={width}
      destroyOnClose
      maskClassName="tools-detail-mask"
      styles={{
        mask: { backdropFilter: 'blur(6px)' },
      }}
    >
      <div className="detail-modal-body">
        {children}
      </div>
    </Modal>
  );
}
